module.exports = __webpack_public_path__ + "img/connect-1-zh-m.8470dd56.png";